import {Node} from './state'
import AppState from '../../types/app-state'

export const nodesLoadingSelector = (state: AppState): boolean => state.nodes.isFetching
export const nodesSelector = (state: AppState): Node[] => state.nodes.nodes
